
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"14","height":"14","rx":"7","fill":"#fff","stroke":"#545C69"}}),_c('rect',{attrs:{"x":"4.102","y":"4.1","width":"7.8","height":"7.8","rx":"3.9","fill":"#545C69"}})])
          )
        }
      }
    